import { z } from "zod"
import { stringRequired } from "@/models/common"

export const DummyConnectVideoSchema = z.object({
  roomSid: stringRequired,
  patientToken: stringRequired,
})

export type DummyConnectVideoForm = z.infer<typeof DummyConnectVideoSchema>
